/* Черновик «Текста» без React (план вехи 3, text-cover §2.2 «text-draft.ts»): общее правило черновика экрана (engine-kit/studio-draft.ts)
   с ключом и хранилищем родной формы (native/use-text-draft.ts): sessionStorage `steos:text:draft:<owner>:<app>`, запись через 250 мс. */
import type { OrderService } from '../studio/engine-kit/order-service';
import { createStudioDraft, type StudioDraft } from '../studio/engine-kit/studio-draft';

export const textDraftKey = (owner: number, app: number) => `steos:text:draft:${owner}:${app}`;

export type TextDraft = StudioDraft;

export function createTextDraft(o: { svc: OrderService; seeded: boolean; changed(): void }): TextDraft {
  return createStudioDraft({ ...o, storage: () => sessionStorage, key: textDraftKey, delay: 250 });
}
